import moment from "moment";
import { paginationData } from "../utilities/functions";
import { fetchApi } from "./fetchApi";

const getDomain = ({
  search,
  view,
  cntxt,
  formattedStartDate,
  formattedEndDate,
  oldDomain,
  model,
}) => {
  const { type } = search;
  let domain =
    view === "kanbanView"
      ? oldDomain
      : view === "timeoff"
      ? [
          "&",
          ["type", "=", "opportunity"],
          ["user_id", "=", cntxt.uid],
          ["activity_date_deadline", ">=", formattedStartDate],
          ["activity_date_deadline", "<=", formattedEndDate],
        ]
      : [];

  if (model === "crm.lead" && view === "taskList") {
    domain = ["&", ["type", "=", "opportunity"], ["user_id", "=", cntxt.uid]];
    if (oldDomain.length > 0) {
      const popElement = domain.pop();
      domain.push("&");
      if (type) {
        domain.push("&");
      }
      domain = [...domain, popElement, ...oldDomain];
    }
  }
  if (type) {
    domain.push("&", ...JSON.parse(type));
  }

  return domain;
};

// Function to pad zero to single digit numbers
function padZero(num) {
  return (num < 10 ? "0" : "") + num;
}
// Function to format date as "YYYY-MM-DD HH:mm:ss"
function formatDate(date) {
  var year = date.getFullYear();
  var month = padZero(date.getMonth() + 1);
  var day = padZero(date.getDate());
  var hours = padZero(date.getHours());
  var minutes = padZero(date.getMinutes());
  var seconds = padZero(date.getSeconds());
  return (
    year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
  );
}
function getStartEndDate() {
  const currentDate = new Date();

  // Get the first day of the current month
  const startDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  startDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

  // Get the last day of the current month
  const endDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999

  return {
    formattedStartDate: formatDate(startDate),
    formattedEndDate: formatDate(endDate),
  };
}

export async function searchRead(...args) {
  const [
    comp_id,
    cntxt,
    view,
    domain,
    startEndDate,
    pagination,
    search = { query: "", type: "" },
    sort = { type: "", dir: "asc" },
    model = "crm.lead",
  ] = args;
  // Get current date
  let { formattedStartDate, formattedEndDate } = getStartEndDate();
  if (startEndDate) {
    formattedStartDate = moment(startEndDate.startDate).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    formattedEndDate = moment(startEndDate.endDate).format(
      "YYYY-MM-DD HH:mm:ss"
    );
  }

  const myHeaders = new Headers();
  myHeaders.append("Accept", "application/json, text/javascript, */*; q=0.01");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Requested-With", "XMLHttpRequest");
  const kanbanFields = [
    "stage_id",
    "color",
    "priority",
    "expected_revenue",
    "kanban_state",
    "activity_date_deadline",
    "user_email",
    "user_id",
    "partner_id",
    "activity_summary",
    "active",
    "company_currency",
    "activity_state",
    "activity_ids",
    "name",
    "tag_ids",
    "activity_exception_decoration",
    "activity_exception_icon",
  ];
  const listFields = [
    "date_deadline",
    "create_date",
    "name",
    "partner_id",
    "contact_name",
    "email_from",
    "phone",
    "company_id",
    "city",
    "state_id",
    "country_id",
    "user_id",
    "team_id",
    "priority",
    "activity_ids",
    "activity_exception_decoration",
    "activity_exception_icon",
    "activity_state",
    "activity_summary",
    "activity_type_id",
    "activity_type_icon",
    "activity_user_id",
    "activity_date_deadline_my",
    "campaign_id",
    "medium_id",
    "source_id",
    "company_currency",
    "expected_revenue",
    "stage_id",
    "active",
    "probability",
    "tag_ids",
    "referred",
    "message_needaction",
  ];
  const timeoffFields = [
    "display_name",
    "activity_date_deadline",
    "expected_revenue",
    "partner_id",
    "user_id",
  ];
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      method: "search_read",
      model,
      domain: getDomain({
        model,
        search,
        view,
        cntxt,
        formattedStartDate,
        formattedEndDate,
        oldDomain: domain,
      }),

      // domain:getDomain(domain),
      fields:
        view === "kanbanView"
          ? kanbanFields
          : view === "timeoff"
          ? timeoffFields
          : view === null
          ? []
          : listFields,
      ...paginationData(pagination),
      sort: sort?.type ? `${sort?.type} ${sort?.dir}` : "", //   direction in the sorting parameter
      context: {
        lang: cntxt.lang,
        tz: cntxt.tz,
        uid: cntxt.uid,
        allowed_company_ids: [comp_id],
        params: {
          cids: comp_id,
          model,
          view_type: view === "kanbanView" ? "kanban" : "list",
        },
        default_type: "opportunity",
        search_default_assigned_to_me: 1,
        bin_size: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  return fetchApi({ requestOptions, endpoint: `/web/dataset/search_read` });
}
